import { render, staticRenderFns } from "./customer-service-walkin.vue?vue&type=template&id=5bed9236"
import script from "./customer-service-walkin.vue?vue&type=script&lang=js"
export * from "./customer-service-walkin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports